import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'
import { getHeader } from '../util/axios_helper'
import { getV1JWTWithoutRefresh } from '../util/jwt_helper'

// Configure request setup
const serviceName = 'LogsService'
const host = servicesConfig.Logs
const opts: CustomAxiosHeaders = { host, serviceName }
const headers = getHeader()
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const LogsService = {
  metric: (data: { [key: string]: any }) => {
    try {
      const index = `frontend-performance-${new Date().toISOString().split('T')[0]}`
      return request().post(`/metric`, { index, body: data, headers: {
        ...headers,
        authorization: `Bearer ${getV1JWTWithoutRefresh()}`,
      }, }).then(responseBody)
    } catch (error) {
      console.error('Error logging metric to ES', error)
    }
  },

  dump: (indexPrefix: string, data: { [key: string]: any }) => {
    try {
    const index = `${indexPrefix}-${new Date().toISOString().split('T')[0]}`
    return request().post(`/metric`, { index, body: data, headers: {
      ...headers,
      authorization: `Bearer ${getV1JWTWithoutRefresh()}`,
    }, }).then(responseBody)
    } catch (error) {
      console.error('Error logging dump to ES', error)
    }
  }
}

export default LogsService
